import { useState } from "react";
import { SiteHeader } from "../../components/header/header";
import { NavComponent } from "../../components/header/nav-component";
import { UseCartList } from "../../services/cart/cart.context";
import { ItemCard } from "../../components/cards/item-card";
import { SiteFooter } from "../../components/footer/footer";

export const WishList = () => {
    const { wishList, saveToWishList } = UseCartList();
    const [openCart, setOpenCart] = useState(false);

    return (
        <div className="f-pg app-pg">
            <SiteHeader />
            {wishList?.length > 0 ?
                (<div className="car-list">
                    {wishList?.map((car) => (
                        <ItemCard
                            item={car}
                            openCart={() => setOpenCart(true)}
                            wishList={wishList}
                            addToList={() => saveToWishList(car)}
                        />
                    ))}
                </div>
                ) : (
                    <div className="no-items">
                        No items in wish list
                    </div>
                )
            }
        <SiteFooter />
        </div>
    );
}